import { Accordion, AccordionDetails, AccordionSummary, Checkbox, Dialog, DialogContent, DialogTitle, FormControlLabel, FormGroup, TablePagination } from "@mui/material";
import styles from "../../tenantdetails.module.css";
import axios from "axios";
import { ArrowLeft, Calendar, ChevronDown, Filter, Plus, Printer, Search, X } from "react-feather";
import { Dropdown } from "react-bootstrap";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useEffect, useState } from "react";
import moment from "moment";
import AddBill from "../../../payment/paymentcomps/AddBill";
import RecordPayment from "../../../payment/paymentcomps/RecordPayment";
import AddCredit from "../../../payment/paymentcomps/AddCredit";
import { useAuth0 } from "@auth0/auth0-react";
import { DateRangePicker } from "rsuite";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import RentRollPrintView from "../../../income/all-income/components/income-grid/income-grid-details/RentRollPrintView";

const PaymentsTab = ({ tenantData, setTenantData, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
  const [page, setPage] = useState(0);
  const [paymentList, setPaymentList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [filterKey, setFilterKey] = useState("");
  const [expanded2, setExpanded2] = useState(false);
  const [paymentFilterType, setPaymentFilterType] = useState({ bill: true, credit: true, payment: true });
  const [paymentFilterText, setPaymentFilterText] = useState("All");
  const [perPage, setPerPage] = useState(5);
  const [addBillModalShow, setAddBillModalShow] = useState(false);
  const [addCreditModalShow, setAddCreditModalShow] = useState(false);
  const [addPaymentModalShow, setAddPaymentModalShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [editId, setEditId] = useState(0);
  const [incomeCategories, setIncomeCategories] = useState([]);
  const [dateFilterData, setDateFilterData] = useState(null);
  const [propertyDetails, setPropertyDetails] = useState(null);
  const [rentRollData, setRentRollData] = useState(null);

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Rent Ledger - ${rentRollData?.tenant_name || "Report"}`,
    pageStyle: `
      @page {
        size: auto;
        margin: 15mm 10mm 10mm 10mm !important;
      }
      body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background: #fff !important;
      }
      html {
        background: #fff !important;
      }
    `,
  });

  useEffect(() => {
    setRentRollData({ tenant_name: tenantData?.all_tenants[0]?.full_name, property_name: tenantData?.property?.name, apt_name: tenantData?.apartment?.apt_no, lease_term: tenantData?.lease_term ? tenantData?.lease_term : ' - ', balance: tenantData?.balance })
  }, [tenantData]);

  useEffect(() => {
    const fetchPropeetyDetails = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-details/" + tenantData?.property_id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setPropertyDetails(response.data.data);
      });
    };
    if (tenantData?.property_id)
      fetchPropeetyDetails();
  }, [tenantData?.property_id, getAccessTokenSilently]);

  useEffect(() => {
    if (tenantData?.payments) {
      let paymentTempList = tenantData?.payments;

      paymentTempList = paymentTempList.sort(function (a, b) {
        if (a.date_new === b.date_new) {
          return a.id - b.id;
        } else {
          return new Date(a.date_new) - new Date(b.date_new);
        }
      });

      paymentTempList = paymentTempList.sort((a, b) => {
        if (new Date(b.date) > new Date(a.date)) {
          return -1;
        } else if (new Date(b.date) === new Date(a.date)) {
          if (parseInt(b.id) > parseInt(a.id)) {
            return -1;
          }
        }
        return 1;
      });

      let balanceNew = 0;
      paymentTempList = paymentTempList?.map((i) => {
        let dueAmount = 0;
        let payAmount = 0;
        if (i?.type === 1) {
          dueAmount = parseFloat(i?.amount);
          balanceNew += parseFloat(i?.amount);
        }
        if (i?.type === 2) {
          dueAmount = parseFloat(balanceNew);
          balanceNew -= parseFloat(i?.amount);
          payAmount = parseFloat(i?.amount);
        }
        let FdueAmount = dueAmount.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        let FbalanceNew = balanceNew.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        let FpayAmount = payAmount.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        return { ...i, due_amount_new: FdueAmount, balance_amount_new: FbalanceNew, payment_amount_new: FpayAmount };
      });

      paymentTempList = paymentTempList.reverse();

      if (filterKey !== "") {
        let inputVal = filterKey.toLowerCase();
        paymentTempList = paymentTempList.filter((item) => {
          return (item.description.toLowerCase().includes(inputVal) || item.formatted_amount.toLowerCase().includes(inputVal));
        });
      }

      let payfilterNo = 0;
      if (paymentFilterType?.bill) {
        payfilterNo++;
      } else {
        paymentTempList = paymentTempList.filter((i) => i?.type !== 1);
      }

      if (paymentFilterType?.credit) {
        payfilterNo++;
      } else {
        paymentTempList = paymentTempList.filter((i) => i?.type !== 2 || i?.payment_type !== "add-credit");
      }

      if (paymentFilterType?.payment) {
        payfilterNo++;
      } else {
        paymentTempList = paymentTempList.filter((i) => i?.type !== 2 || i?.payment_type === "add-credit");
      }
      if (payfilterNo >= 3) {
        setPaymentFilterText("All");
      } else {
        setPaymentFilterText(payfilterNo + " Selected");
      }

      if (dateFilterData && dateFilterData !== "") {
        paymentTempList = paymentTempList.filter((i) => {
          if (moment(moment(i.date).format("YYYY-MM-DD")).isBetween(moment(dateFilterData[0]).format("YYYY-MM-DD"), moment(dateFilterData[1]).format("YYYY-MM-DD"), undefined, [])) {
            return true;
          }
          return false;
        });
      }

      setPaymentList(paymentTempList);
    }
  }, [tenantData, filterKey, paymentFilterType, dateFilterData]);

  useEffect(() => {
    const fetchIncomeCategory = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/income-categories", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setIncomeCategories(response.data.data);
      });
    };

    fetchIncomeCategory();
  }, [getAccessTokenSilently]);

  const addData = (data) => {
    setTenantData((prev) => {
      return { ...prev, payments: [data].concat(prev.payments) };
    });
  };

  const updateData = (data) => {
    console.log(data);
  };

  return (<>
    <div className={`${styles.NotesSearchArea}`}>
      <div className={`${styles.FilterSearchSec}`}>
        <div className={`${styles.NotesSearchMain}`}>
          <Search />
          <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setFilterKey(e.target.value)} />
        </div>
        <div style={{ width: "195px", padding: "0 15px 0 0" }}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`} style={{ width: "180px" }}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              value={dateFilterData && Array.isArray(dateFilterData) ? dateFilterData : null}
              onChange={(e) => setDateFilterData(e)}
            />
          </div>
        </div>
        <Dropdown>
          <Dropdown.Toggle className={`${styles.ActionsBULine} ActionsBULine`} id="dropdown-basic">
            <span className={`${styles.ReqBigFilter}`}>
              Show: {paymentFilterText} <ChevronDown />
            </span>
            <span className={`${styles.ReqSmallFilter}`}>
              <Filter />
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
            <FormGroup row className={`${styles.CheckFilter}`}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="All"
                    color="primary"
                    indeterminate={!(paymentFilterType?.bill && paymentFilterType?.credit && paymentFilterType?.payment) && (paymentFilterType?.bill || paymentFilterType?.credit || paymentFilterType?.payment)}
                    checked={paymentFilterType?.bill && paymentFilterType?.credit && paymentFilterType?.payment}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPaymentFilterType({ bill: true, credit: true, payment: true });
                      } else {
                        setPaymentFilterType({ bill: false, credit: false, payment: false });
                      }
                    }}
                  />
                }
                label="All"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="bill"
                    color="primary"
                    checked={paymentFilterType?.bill}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPaymentFilterType((prev) => {
                          return { ...prev, bill: true };
                        });
                      } else {
                        setPaymentFilterType((prev) => {
                          return { ...prev, bill: false };
                        });
                      }
                    }}
                  />
                }
                label="Bills"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="credit"
                    color="primary"
                    checked={paymentFilterType?.credit}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPaymentFilterType((prev) => {
                          return { ...prev, credit: true };
                        });
                      } else {
                        setPaymentFilterType((prev) => {
                          return { ...prev, credit: false };
                        });
                      }
                    }}
                  />
                }
                label="Credits"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="checkedH"
                    color="primary"
                    checked={paymentFilterType?.payment}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setPaymentFilterType((prev) => {
                          return { ...prev, payment: true };
                        });
                      } else {
                        setPaymentFilterType((prev) => {
                          return { ...prev, payment: false };
                        });
                      }
                    }}
                  />
                }
                label="Payments"
              />
            </FormGroup>
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <button className={`${styles.PrintBU}`}
        variant="outlined"
        color="primary"
        onClick={handlePrint}
      >
        <Printer /> Print
      </button>
      <Dropdown>
        <Dropdown.Toggle className={`${styles.ActionsBU} ${styles.Red} ActionsBU Red`} id="dropdown-basic">
          <Plus /> <span className={`${styles.AddBuText}`}>New</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddBillModalShow(true); setIsUpdate(false); setEditId(0); }}>
            <img src="/static/img/bill-icon.svg" alt="" />
            Bill
          </Dropdown.Item>
          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddCreditModalShow(true); setIsUpdate(false); setEditId(0); }}>
            <img src="/static/img/credit-icon.svg" alt="" />
            Credit
          </Dropdown.Item>
          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddPaymentModalShow(true); setIsUpdate(false); setEditId(0); }}>
            <img src="/static/img/bank-icon.svg" alt="" />
            Payment
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>

    {/* <Button
      variant="outlined"
      color="primary"
      onClick={handlePrint}
      style={{ marginLeft: "10px" }}
    >
      Print Rent Roll
    </Button> */}

    <div style={{ display: 'none' }}>
      <RentRollPrintView
        ref={printRef}
        propertyDetails={propertyDetails}
        rentRollData={rentRollData}
        rentList={paymentList}
      />
    </div>

    {paymentList.length > 0 && (<div className={`${styles.RentRollListSec}`}>
      <div className="FormAccording TenantDetails Theme Shadow">
        {paymentList.map((itemP, index) => {
          return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<Accordion expanded={expanded2 === `panell${index}`} onChange={(e, t) => setExpanded2(t ? `panell${index}` : false)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
              <div className={`${styles.NotesCard2}`}>
                <div className={`${styles.AlertCardFirstSec}`}>
                  <div className={`${styles.AccoTitleHead}`}>
                    <div className={`${styles.CardStatusSec}`}>
                      <p className={`${styles.DateInfoAcc}`}>
                        {itemP?.type === 1 && (<img src="/static/img/bill-icon.svg" alt="" className={`${styles.StatusIcon}`} />)}
                        {itemP?.type === 2 && itemP?.payment_type !== "online-payment" && (<img src="/static/img/credit-icon.svg" alt="" className={`${styles.StatusIcon}`} />)}
                        {itemP?.type === 2 && itemP?.payment_type === "online-payment" && (<img src="/static/img/bank-icon.svg" alt="" className={`${styles.StatusIcon}`} />)}
                        <div>
                          {itemP?.type === 1 && (<p className={`${styles.DueOnBadge}`}>Bill Due On</p>)}
                          {itemP?.type === 2 && itemP.payment_type === "add-credit" && (<p className={`${styles.CreditedBadge}`}>Credit Applied On</p>)}
                          {itemP?.type === 2 && itemP.payment_type === "record-payment" && (<p className={`${styles.CreditedBadge}`}>Payment Applied On</p>)}
                          {itemP?.type === 2 && itemP?.payment_type === "online-payment" && itemP?.payment_status === 0 && (<p className={`${styles.PendingBadge}`}>Payment Sent: Pending</p>)}
                          {itemP?.type === 2 && itemP?.payment_type === "online-payment" && itemP?.payment_status === 1 && (<p className={`${styles.CreditedBadge}`}>Payment Sent: Completed</p>)}
                          {itemP?.type === 2 && itemP?.payment_type === "online-payment" && itemP?.payment_status === 2 && (<p className={`${styles.FailedBadge}`}>Payment Sent: Failed</p>)}
                          <p className={`${styles.BadgeDate}`}>{moment(itemP.date).format("LL")}</p>
                        </div>
                      </p>
                    </div>
                    <div className={`${styles.CardDesSec}`}>
                      <p className={`${styles.DateInfo}`}>{itemP.description}</p>
                    </div>
                    <div className={`${styles.CardAmountSec}`}>
                      <div>
                        <p className={`${styles.DateInfo}`}>
                          <span>Due:</span>
                          {itemP?.due_amount_new}
                        </p>
                      </div>
                      <div>
                        <p className={`${styles.DateInfo}`}>
                          <span>Payment:</span>
                          {itemP?.type === 2 ? itemP?.payment_amount_new : "-"}
                        </p>
                      </div>
                      <div>
                        <p className={`${styles.DateInfo}`}>
                          <span>Balance:</span>
                          {itemP?.balance_amount_new}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails className={`${styles.CussAccoRow}`}>
              <div className={`${styles.AccoMainSec}`}>
                <ul>
                  <li className={`${styles.CardDesList}`}>
                    <p className={`${styles.AlertText}`}>
                      <span>Description:</span> {itemP.description}
                    </p>
                  </li>
                  {itemP?.type === 1 && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Invoice No</span>{" "}
                      {100000 + parseInt(itemP.id)}
                    </p>
                  </li>)}
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Payer</span> {itemP?.payment_details?.payer}
                    </p>
                  </li>)}
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Memo</span> {itemP?.payment_details?.memo}
                    </p>
                  </li>)}
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Amount</span>{" "}
                      {itemP?.payment_details?.formatted_amount}
                    </p>
                  </li>)}
                  <li>
                    <p className={`${styles.AlertText}`}>
                      <span>Type</span> {itemP?.recurring_type}
                    </p>
                  </li>
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Status</span>{" "}
                      {itemP?.payment_details?.status}
                    </p>
                  </li>)}
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Estimated deposit date</span>{" "}
                      {moment(itemP.date).format("MMM D, YYYY")}
                    </p>
                  </li>)}
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Payment method</span>
                      {itemP?.payment_details?.payment_method ===
                        "card" && "Credit Card"}
                      {itemP?.payment_details?.payment_method ===
                        "us_bank_account" && "ACH Bank Transfer"}
                    </p>
                  </li>)}
                  {itemP.payment_type === "online-payment" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>To account</span>{" "}
                      {itemP?.payment_details?.account}
                    </p>
                  </li>)}
                  {itemP?.payment_details?.status === "Failed" && (<li>
                    <p className={`${styles.AlertText}`}>
                      <span>Failure Message</span>{" "}
                      {itemP?.payment_details?.failure_message}
                    </p>
                  </li>)}
                </ul>
              </div>
            </AccordionDetails>
          </Accordion>) : null;
        })}

        {paymentList.length > 0 && (<div className="Pagination TablePaginationNew">
          <TablePagination
            count={paymentList.length}
            color="primary"
            page={page}
            rowsPerPage={perPage}
            onPageChange={(e, v) => setPage(v)}
            rowsPerPageOptions={[
              { label: "5", value: 5 },
              { label: "10", value: 10 },
              { label: "15", value: 15 },
              { label: "All", value: -1 },
            ]}
            onRowsPerPageChange={(e) => {
              setPage(0);
              setPerPage(e.target.value);
            }}
            labelRowsPerPage={"Payments per Page:"}
          />
        </div>)}
      </div>
    </div>
    )}

    {paymentList.length === 0 && (<div className={`${styles.NoDataMain}`}>
      <div className={`${styles.NoDataIMG}`}>
        <img src="/static/img/no-payment.png" alt="No Data" />
      </div>
      <p className={`${styles.NoDataText}`}>Unfortunately!</p>
      <p className={`${styles.NoDataTextSub}`}>We haven't received any payment at this time.</p>
    </div>)}

    <Dialog
      fullWidth
      maxWidth="xs"
      open={addBillModalShow}
      onClose={(e) => setAddBillModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddBillModalShow(false)}>
          <ArrowLeft />
        </button>
        {isUpdate ? "Update Bill" : "Add Bill"}
        <button onClick={(e) => setAddBillModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <AddBill
          rent_roll_id={tenantData?.last_rent_roll_id}
          setModalShow={setAddBillModalShow.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          addData={addData.bind(this)}
          updateData={updateData.bind(this)}
          isUpdate={isUpdate}
          editId={editId}
          incomeCategories={incomeCategories}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      fullWidth
      maxWidth="xs"
      open={addCreditModalShow}
      onClose={(e) => setAddCreditModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddCreditModalShow(false)}>
          <ArrowLeft />
        </button>
        {isUpdate ? "Update Credit" : "Add Credit"}
        <button onClick={(e) => setAddCreditModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <AddCredit
          rent_roll_id={tenantData?.last_rent_roll_id}
          setModalShow={setAddCreditModalShow.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          addData={addData.bind(this)}
          updateData={updateData.bind(this)}
          isUpdate={isUpdate}
          editId={editId}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      fullWidth
      maxWidth="xs"
      open={addPaymentModalShow}
      onClose={(e) => setAddPaymentModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddPaymentModalShow(false)}>
          <ArrowLeft />
        </button>
        {isUpdate ? "Update Payment" : "Record Payment"}
        <button onClick={(e) => setAddPaymentModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <RecordPayment
          rent_roll_id={tenantData?.last_rent_roll_id}
          setModalShow={setAddPaymentModalShow.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          addData={addData.bind(this)}
          updateData={updateData.bind(this)}
          isUpdate={isUpdate}
          editId={editId}
        />
      </DialogContent>
    </Dialog>
  </>);
};

export default PaymentsTab;